<template lang="pug">
    section#banner
        div.wrapper
            div.container
                //- div.img
                //-     img(:src="require('@images/transferencia/com-certeza.png')", alt="Não se engane, faça UniFAEL")
                div.texto
                    h3
                        |TRANSFERÊNCIA
                        br
                        |E APROVEITAMENTO
                    p
                        |Com a gente não tem engano! Tem desconto na transferência e aproveitamento do que você já aprendeu no seu curso. Consulte o polo mais próximo e faça UniFAEL!
</template>

<script>
export default {
    name: "section-banner"
}
</script>

<style lang="stylus" scoped src="./Banner.styl"></style>
